import {
  Component,
  DestroyRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DISPLAY_CONSTANTS } from './app.constants';
import { IMAGE_SRC } from './components/shared/shared-constants';
import { AuthenticationService } from './core/auth/authentication.service';
import { CommonUtils } from './core/utils/common/common.utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  commonUtils = inject(CommonUtils);
  // private userService = inject(UserService);
  private titleService = inject(Title);
  private router = inject(Router);
  private matDialog = inject(MatDialog);
  private destroy = inject(DestroyRef);
  private authService = inject(AuthenticationService);

  readonly IMAGES = IMAGE_SRC;

  @ViewChild('notifications') notifications?: MatSidenav;

  ngOnInit() {
    this.titleService.setTitle(DISPLAY_CONSTANTS.APP_NAME.WEB);

    this.router.events.pipe(takeUntilDestroyed(this.destroy)).subscribe(() => {
      //On every route change close the banner and reset the file upload response
      this.commonUtils.fileUploadResponse.set({
        uniqueUploadId: '',
        fileName: '',
        fileSize: 0,
        accepted: 0,
        rejected: [],
        received: 0,
        itemsNonProcessed: [],
      });
      this.commonUtils.updateBanner(false);
    });

    this.matDialog.afterOpened
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe(() => {
        //On every dialog open, close the banner and reset the file upload response
        this.commonUtils.fileUploadResponse.set({
          uniqueUploadId: '',
          fileName: '',
          fileSize: 0,
          accepted: 0,
          rejected: [],
          received: 0,
          itemsNonProcessed: [],
        });
        this.commonUtils.updateBanner(false);
      });

    // this.handleUserLanguage();

    this.authService.init();
  }

  //Currently no language support, so commenting out
  // private handleUserLanguage(): void {
  //   this.userService
  //     .getCurrentUser$()
  //     .pipe(
  //       skip(1),
  //       takeUntilDestroyed(this.destroy),
  //       tap((user) => {
  //         if (user?.defaultLanguage) {
  //           const currentLang = user.defaultLanguage.toLowerCase();
  //           currentLocale.set(this.matchLocale(currentLang));
  //           const path = window.location.pathname;
  //           //Check if user's default language is already routed to.  If it isn't then route to it
  //           if (
  //             path.substring(1, 3).toLowerCase() !== currentLocale() &&
  //             !(path === '/' && currentLocale() === 'en')
  //           ) {
  //             window.location.assign(
  //               `${window.location.protocol}//${window.location.host}/${currentLocale()}${path.substring(3, path.length)}`,
  //             );
  //           }
  //         }
  //       }),
  //     )
  //     .subscribe();
  // }

  // private matchLocale(val: string): string {
  //   const browserLang = navigator.language.substring(0, 2).toLowerCase();
  //   const matchedLang = AVAILABLE_LANGUAGES.find(
  //     (lang) => val === lang.toString(),
  //   );
  //   const matchedBrowserLang = AVAILABLE_LANGUAGES.find(
  //     () => val === browserLang.toString(),
  //   );
  //   if (matchedLang) {
  //     return matchedLang;
  //   } else {
  //     if (matchedLang === '00') {
  //       //Default should go to browser's language, if not in list of languages then default to english
  //       return matchedBrowserLang !== undefined
  //         ? matchedBrowserLang
  //         : Language.ENGLISH.toLowerCase();
  //     } else {
  //       //Any non-matched languages should default to english
  //       return Language.ENGLISH.toLowerCase();
  //     }
  //   }
  // }
}
